var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { ProjectObjectType } from "@@/Project";
import { action, makeObservable, observable } from "mobx";
import { FileUploadDialogState } from "@/app/UIComponents/FileUploadDialog";
import { ProjectNewFolderState } from "@/app/UIComponents/ProjectNewFolder";
import { BookmarkState } from "@/app/UIComponents/BookmarkDialog";
import { ObjectRenameState } from "@/app/UIComponents/ProjectObjectRenameDialog";
import { NewDocumentDialogState } from "@/app/uistore/NewDocumentState";
import { LetrRequestType } from "@/share/Letr";
import { LeterPermissionType } from "@@/Letr";
import { AccessGroupState } from "./AccessgroupState";
import { SearchDataType } from "@@/ModuleJob";
import { ExpandableTreeState } from "../UIComponents/ExpandableTree";
import { TableRenderState } from "./TableRenderState";
import { formatBytes } from "@@/Util";
import { DateLib } from "@@/Datelib";
import { CHATID } from "@@/Tags";
import { VDState } from "./VersionDialogState";
import { ROOTFolder } from "../const/AppDefaults";
import { Router } from "./Router";
import { FilterDialogState } from "../UIComponents/FilterDialogState";
export const TRASHFolder = "trash";
export var UpdateType;
(function (UpdateType) {
    UpdateType[UpdateType["Rename"] = 0] = "Rename";
    UpdateType[UpdateType["Version"] = 1] = "Version";
    UpdateType[UpdateType["None"] = 2] = "None";
})(UpdateType || (UpdateType = {}));
export class ProjectStore {
    constructor() {
        this.projectsobject = new Map();
        this.searchstore = new Map();
        this.actvefolderselectitem = new Set();
        this.cview = [];
        this.loading = false;
        this.activeletrid = "";
        this.activefolderid = "";
        this.openviewermenu = false;
        this.filterdialogstate = new FilterDialogState();
        this.activetag = "";
        this.openactionmenu = false;
        this.selecteditems = new Set();
        this.trashing = false;
        this.deleteingitems = false;
        this.showsearchresult = false;
        this.hidecoilumn = new Set();
        this.fullfolderselected = new Set();
        this.updatetype = UpdateType.None;
        this.copyitems = new Set();
        this.cutitems = new Set();
        this.cutItemsProjectObject = new Map();
        this.copyItemsProjectObject = new Map();
        this.cutpasting = false;
        this.copypasting = false;
        this.recovering = false;
        this.showcolview = false;
        this.emptytrashing = false;
        this.updatesecondpanel = false;
        this.searchactive = false;
        this.searching = false;
        this.searchterm = "";
        this.filterfolderterm = "";
        this.savingrow = false;
        this.foundmsg = "";
        this.showfilter = false;
        this.metaitems = new Map();
        this.editrowproperty = new Map();
        this.initobjectid = "";
        this.initnoteid = "";
        this.userid = "";
        this.myperm = LeterPermissionType.View;
        this.showpasswordfor = new Set();
        this.searchprogressmessage = "";
        this.activeitemid = ""; // this is the item showing in right panel
        this.loadingmoresearch = false;
        this.searchmatches = [];
        this.documentTableState = new TableRenderState();
        this.accessstorestate = new AccessGroupState();
        this.renamestate = new ObjectRenameState();
        this.newdocumentstore = new NewDocumentDialogState((name, type) => {
            this.startNewDraft(name, type);
        });
        this.ongoingcreaterequests = 0;
        this.loadedfolder = -1;
        this.memberDetail = [];
        this.letrlinks = [];
        this.showdropzone = false;
        this.trashactive = false;
        this.folders = new Map();
        this.projecttreestate = new ExpandableTreeState();
        this.atimeout = undefined;
        this.activefolderselected = new Set();
        this.vieweractive = false;
        this.selectedFolder = [
            {
                folderid: ROOTFolder,
                name: "Home",
                index: 0
            }
        ];
        this.loadinginitobject = false;
        this.newfolderstate = new ProjectNewFolderState();
        this.fileuploadstate = new FileUploadDialogState();
        this.bookmarkstate = new BookmarkState();
        this.loadState = -1;
        this.projectobjectsByFolderId = new Map();
        this.showfolderview = false;
        makeObservable(this);
        APPEvent.addSubscriberForUserID((id) => this.userid = id);
        APPEvent.addSubscriberForProjectObjectDetails((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchterm) {
                res.objs.forEach((obj) => {
                    this.addSearchResult(obj);
                });
                this.setSearching(false);
                this.setLoadingMoreSearch(false);
            }
            else if (this.loadinginitobject &&
                res.letrid === this.activeletrid && res.reqid === this.initobjectid) {
                if (res.objs.length > 0) {
                    const obj = res.objs[0];
                    //lets exand all parent!!
                    this.expandFolder(obj.parentid);
                    this.projecttreestate.setActiveItem(obj.parentid);
                    // we have done this no!
                }
                this.setLoadingInitObject(false);
            }
        });
        APPEvent.addSubcriberForGetMetadataa((res) => {
            if (res.isChooser) {
                return;
            }
            const meta = res.data;
            this.clearMetadata();
            for (const mt of meta) {
                if (mt.letrid === this.activeletrid) {
                    this.addMetadata(mt);
                }
            }
            this.addHeaders();
        });
        APPEvent.addSubscriberForSearchMatchResp((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.searchtext === this.searchterm) {
                if (res.matches === undefined) {
                    this.documentTableState.clearRows();
                    this.projecttreestate.hideAll();
                    this.setSearching(false);
                    this.setSearchFoundMessage("No matches");
                }
                else {
                    const pids = new Set();
                    for (const re of res.matches.result) {
                        for (const d of re.indexdata) {
                            pids.add(d.itemid);
                        }
                    }
                    if (pids.size === 0) {
                        this.documentTableState.clearRows();
                        this.projecttreestate.hideAll();
                        this.setSearching(false);
                        this.setSearchFoundMessage("No matches");
                    }
                    else {
                        this.setSearchFoundMessage(pids.size + " match" + (pids.size > 1 ? "es" : ""));
                        // we should fist download all the parents and then maybe we should show the result
                        this.downloadParentForObjects(Array.from(pids));
                        this.searchmatches = Array.from(pids);
                        /*
                        this.setSearchProgess("Downloading object" + (pids.size > 1 ? "s" : "") + "...");
                        
                        const req: ProjectIdDetailRequest = {
                            letrid: this.activeletrid,
                            ids: this.searchmatches.splice(0, 50),
                            reqid: this.searchterm
                        };

                        Apphandler.sendMessage("driveprojectids", req);*/
                    }
                }
            }
        });
        APPEvent.addSubscriberForObjectParentFolder((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.id === this.searchterm) {
                // now we have everything to display our result
                // we need to hide all folders and only show the parent tree stuff
                // on click we can just display the matching reuslt 
                this.setActiveFolderId("");
                this.documentTableState.clearRows();
                this.projecttreestate.hideAll();
                this.showSearchParentResult(res.parent);
                this.setSearching(false);
            }
        });
        APPEvent.addSubscriberForProjectObject((obj) => {
            this.addProjectObject(obj);
        });
        APPEvent.addSubscriberForEmptyTrash((em) => {
            if (this.emptytrashing) {
                if (em) {
                    this.clearTrash();
                }
                this.setEmptyTrashing(false);
            }
        });
        APPEvent.addSubscriberForCreateObject((obj) => {
            var _a;
            if (this.ongoingcreaterequests > 0 &&
                obj.letrid === this.activeletrid) {
                this.ongoingcreaterequests--;
                //lets add this object now that's it
                if (obj.project !== undefined) {
                    this.addProjectObject(obj.project);
                    if (obj.project.type === ProjectObjectType.Draft && this.newdocumentstore.creating) {
                        this.newdocumentstore.setCreating(false);
                        // we need draft selection as well here!!
                        this.newdocumentstore.hide();
                        (_a = this.draftCreatedCb) === null || _a === void 0 ? void 0 : _a.call(this, obj.project);
                    }
                }
                if (this.ongoingcreaterequests === 0 && this.copypasting) {
                    this.setCopyPasting(false);
                    this.copyitems.forEach((it) => this.setObjectSelection(it, false));
                    this.resetCopyItems();
                }
            }
        });
        APPEvent.addSubscriberForActiveLetr((lt) => {
            this.setActiveLetr(lt);
            this.showHome(false);
            if (this.activetag !== CHATID) {
                this.loadAllFolders();
            }
        });
        APPEvent.addSubcriberForAddField((req) => {
            if (this.savingrow && req.letrid === this.activeletrid && req.objectid === this.activeitemid) {
                if (req.obejct) {
                    this.updateUIObject(req.obejct);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to update the object");
                }
                this.setSavingRow(false);
            }
        });
        APPEvent.addSubscriberForLetrsResponse((res) => {
            var _a, _b;
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined) {
                if (this.activeletrid === res.letrid) {
                    // lets keeo the 
                    this.memberDetail = res.letrdetail.memberDetails;
                    this.setMyLetrPerm((_b = (_a = res.letrdetail) === null || _a === void 0 ? void 0 : _a.mypermission.permission) !== null && _b !== void 0 ? _b : LeterPermissionType.View);
                    if (this.activefolderid === "") {
                        this.setActiveFolderId(ROOTFolder);
                    }
                }
            }
        });
        this.addHeaders();
        APPEvent.addSubscriberForGetLetrlink((links) => {
            if (links.letrid === this.activeletrid) {
                this.letrlinks = links.links;
            }
        });
        APPEvent.addSubscriberForProjectFolders((folder) => {
            if (folder.letrid === this.activeletrid && !folder.isChooser) {
                this.setFolders(folder.folders);
            }
        });
        APPEvent.addSubscriberForProjects((prjs) => {
            if (this.loading && !prjs.isChooser) {
                if (this.activeletrid === prjs.letrid && this.activefolderid === prjs.parentid) {
                    this.addProjectObjects(prjs.projects);
                    this.setLoading(false);
                    if (this.initobjectid) {
                        let found = false;
                        for (const obj of prjs.projects) {
                            if (obj.id === this.initobjectid) {
                                if (obj.type === ProjectObjectType.Document) {
                                    setTimeout(() => {
                                        var _a;
                                        (_a = this.reshowdocumnetn) === null || _a === void 0 ? void 0 : _a.call(this, obj, this.initnoteid);
                                        this.documentTableState.setSelectId(obj.id);
                                        this.setActiveItemid(obj.id);
                                    }, 100);
                                }
                                found = true;
                            }
                        }
                        if (!found) {
                            this.getProjectObjectDetail(this.initobjectid);
                        }
                    }
                }
            }
        });
        APPEvent.addSubscriberForAddVersion((ve) => {
            if (ve.letrid === this.activeletrid && ve.objectid === this.activeitemid) {
                if (ve.vinfo) {
                    VDState.addVersion(ve.vinfo);
                }
                if (this.udatingversion) {
                    this.updateActiveObjectVersion(this.udatingversion);
                }
            }
        });
        APPEvent.addSubscriberForUpdateObject((up) => {
            var _a;
            if (this.updatetype !== UpdateType.None) {
                if (this.updatetype === UpdateType.Rename) {
                    if (up.project !== undefined && up.success) {
                        // okay we should just update the po and then we done 
                        // all we need is look for this object that's it
                        this.projectsobject.set(up.project.id, up.project);
                        // we should now update the nodes in tree and table@
                        this.renamestate.setOpen(false);
                        this.updateUIObject(up.project);
                    }
                    else {
                        this.renamestate.setError("Sorry, failed to rename please try again later");
                        this.renamestate.setLoading(false);
                    }
                }
                else if (this.updatetype === UpdateType.Version) {
                    if (up.project !== undefined && up.success) {
                        this.projectsobject.set(up.project.id, up.project);
                        this.updateUIObject(up.project);
                        if (up.project.type === ProjectObjectType.Document) {
                            const dobj = up.project;
                            (_a = this.reshowdocumnetn) === null || _a === void 0 ? void 0 : _a.call(this, dobj, "");
                            VDState.setActivatedVeriosn(dobj.documentreference);
                            VDState.setActivatingVeriosn("");
                        }
                        // lets now add the version object too!1
                        VDState.setAddingVersion(false);
                    }
                    else {
                        APPEvent.publishApperror("Sory, failed to add activate new version");
                    }
                }
                this.updatetype = UpdateType.None;
            }
        });
        APPEvent.addSubscriberForGetVersion((vs) => {
            if (VDState.loading && vs.objectid === this.activeitemid) {
                VDState.setVersions(vs.vinfo);
                VDState.setLoading(false);
            }
        });
        APPEvent.addSubscriberForMoveObject((ob) => {
            if (this.cutpasting && this.cutitems.size > 0) {
                if (ob.success) {
                    const ids = ob.project;
                    for (const id of ids) {
                        const po = this.cutItemsProjectObject.get(id);
                        if (po !== undefined) {
                            this.removeItemFromUI(po);
                            po.parentid = this.activefolderid;
                            this.addProjectObject(po);
                        }
                    }
                    this.cutitems.forEach((it) => this.setObjectSelection(it, false));
                    this.resetCutItems();
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to paste selected item(s). Please try again later.");
                }
                this.setCutPasting(false);
            }
            else if ((this.trashing || this.recovering) && this.selecteditems.size > 0) {
                if (ob.success) {
                    this.selecteditems.forEach((id) => {
                        const ob = this.getProjectObject(id);
                        if (ob !== undefined) {
                            this.removeItemFromUI(ob);
                            ob.parentid = this.trashing ? TRASHFolder : ROOTFolder;
                            if (ob.type === ProjectObjectType.Folder) {
                                // we should change the parentid
                                const fol = this.folders.get(ob.id);
                                if (fol !== undefined) {
                                    fol.parentid = this.trashing ? TRASHFolder : ROOTFolder;
                                    this.addProjectObject(ob);
                                }
                                this.projecttreestate.clearSelected();
                            }
                        }
                        this.removeItemFromProjectObject(id);
                    });
                    this.clearSelectedItems();
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to move selected item(s) to trash. Please try again later.");
                }
                this.setTrashing(false);
                this.setRecovering(false);
            }
            else if (this.deleteingitems) {
                if (ob.success) {
                    this.selecteditems.forEach((id) => {
                        const ob = this.getProjectObject(id);
                        if (ob) {
                            this.removeItemFromUI(ob);
                        }
                        this.removeItemFromProjectObject(id);
                    });
                    this.clearSelectedItems();
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to delete selected item(s). Please try again later.");
                }
                this.setDeleting(false);
            }
        });
    }
    setShowFolderView(show) {
        this.showfolderview = show;
    }
    setMyLetrPerm(perm) {
        this.myperm = perm;
    }
    clearMetadata() {
        this.metaitems.clear();
    }
    addMetadata(mt) {
        this.metaitems.set(mt.id, mt);
    }
    setShowPasswordFor(pwd) {
        this.showpasswordfor.add(pwd);
    }
    setHidePasswordFor(pwd) {
        this.showpasswordfor.delete(pwd);
    }
    setShowColView(show) {
        this.showcolview = show;
    }
    setshowfilter(show) {
        this.showfilter = show;
    }
    getMetadata() {
        return Array.from(this.metaitems.values()).slice().sort((m1, m2) => m1.orderindex - m2.orderindex);
    }
    removePropertiesFromActiveRow(id) {
        this.editrowproperty.delete(id);
    }
    setPropertiesForActiveRow(id, entry) {
        this.editrowproperty.set(id, entry);
    }
    setLoadingInitObject(load) {
        this.loadinginitobject = load;
    }
    getProjectObjectDetail(id) {
        this.setLoadingInitObject(true);
        const req = {
            letrid: this.activeletrid,
            ids: [id],
            reqid: id
        };
        Apphandler.sendMessage("driveprojectids", req);
    }
    showSearchParentResult(objs) {
        let showparentwithcount = new Map();
        // now lets calcualte everything and we done here!!
        for (const obj of objs) {
            let count = 1;
            if (showparentwithcount.has(obj.parentid)) {
                const sj = showparentwithcount.get(obj.parentid);
                if (sj !== undefined) {
                    count = sj + 1;
                }
            }
            showparentwithcount.set(obj.parentid, count);
        }
        this.projecttreestate.hideOrShowItems(ROOTFolder, false);
        for (const [k, count] of showparentwithcount) {
            this.projecttreestate.hideOrShowItems(k, false);
            this.projecttreestate.updateCount(k, count);
            const folder = this.folders.get(k);
            if (folder !== undefined) {
                let parent = folder.parentid;
                while (parent !== ROOTFolder) {
                    this.projecttreestate.hideOrShowItems(parent, false);
                    if (!showparentwithcount.has(parent)) {
                        this.projecttreestate.updateCount(k, 0);
                    }
                    const folder = this.folders.get(parent);
                    if (folder === undefined) {
                        break;
                    }
                    parent = folder.parentid;
                }
            }
        }
    }
    addHeaders() {
        this.documentTableState.clearHeaders();
        const rows = this.documentTableState.getRows();
        this.documentTableState.clearRows();
        this.documentTableState.addHeaders([
            { label: 'Name', id: 'name', index: 0, width: (window.innerWidth * .75) / 2 },
            { label: 'Type', id: 'type', index: 1, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Size', id: 'size', index: 2, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Last Modified', id: 'lastmodified', index: 3, width: window.innerWidth * .75 / 2 / 3.2 }
        ].filter((sh) => !this.hidecoilumn.has(sh.id)));
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            this.documentTableState.addHeaders(mitems.filter((mitem) => !this.hidecoilumn.has(mitem.id)).map((mitem, index) => {
                const ret = {
                    label: mitem.name,
                    id: "custom_" + mitem.id,
                    index: index + 4,
                    width: 400
                };
                return ret;
            }));
        }
        this.addColumnViews();
        this.addProjectObjects(Array.from(this.projectsobject.values()));
    }
    addColumnViews() {
        var _a, _b, _c, _d;
        const lcopy = this.cview;
        this.cview.splice(0, this.cview.length);
        const lmap = new Map();
        lcopy.forEach((lc) => lmap.set(lc.id, lc.hidden));
        const sview = [{ label: 'Name', id: 'name', hidden: (_a = lmap.get("name")) !== null && _a !== void 0 ? _a : false },
            { label: 'Type', id: 'type', hidden: (_b = lmap.get("type")) !== null && _b !== void 0 ? _b : false },
            { label: 'Size', id: 'size', hidden: (_c = lmap.get("size")) !== null && _c !== void 0 ? _c : false },
            { label: 'Last Modified', id: 'lastmodified', hidden: (_d = lmap.get("lastmodified")) !== null && _d !== void 0 ? _d : false }];
        this.cview.push(...sview);
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            mitems.forEach((mi) => { var _a; return this.cview.push({ label: mi.name, id: mi.id, hidden: (_a = lmap.get(mi.id)) !== null && _a !== void 0 ? _a : false }); });
        }
    }
    removeItemFromUI(ob) {
        if (ob.type === ProjectObjectType.Folder) {
            const f = ob;
            this.projecttreestate.removeChild({
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: f.childrencount
            });
        }
        else {
            this.documentTableState.removeRow(ob.id);
        }
        this.projecttreestate.increamentCount(-1, ob.parentid);
    }
    updateUIObject(ob) {
        if (ob.type === ProjectObjectType.Folder) {
            const f = ob;
            this.projecttreestate.updateNode({
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: f.childrencount
            });
        }
        else {
            const robj = this.makeObjectForTable(ob);
            if (robj !== undefined) {
                this.documentTableState.replaceRow(robj);
            }
        }
    }
    expandFolder(id) {
        const fold = this.folders.get(id);
        if (fold) {
            let ptn = fold.parentid;
            let n = 1000;
            while (ptn && n >= 0) {
                n--;
                // lets exand this now!
                const ptnfolder = this.folders.get(ptn);
                if (!ptnfolder) {
                    ptn = "";
                }
                else {
                    ptn = ptnfolder.parentid;
                    this.projecttreestate.setExpandedNode(ptnfolder.id, true);
                }
            }
            this.projecttreestate.setExpandedNode(fold.id, true);
            this.setActiveFolderId(fold.id);
        }
    }
    async downloadParentForObjects(ids) {
        const req = {
            letrid: this.activeletrid,
            ids: ids,
            reqid: this.searchterm
        };
        Apphandler.sendMessage("getobjectparents", req);
    }
    async startNewDraft(name, type) {
        if (this.newdocumentstore.creating) {
            return;
        }
        if (!name || !type) {
            return;
        }
        this.newdocumentstore.setCreating(true);
        const denetity = {
            type: ProjectObjectType.Draft,
            parentid: this.activefolderid,
            updatetime: 0,
            id: "",
            accessids: [],
            name: name,
            drafttype: type,
            draftreference: "",
            accesskey: "",
            draftsize: 0
        };
        const req = {
            letrid: this.activeletrid,
            entity: denetity
        };
        this.ongoingcreaterequests++;
        Apphandler.sendMessage("createdraft", req);
    }
    setSavingRow(sav) {
        this.savingrow = sav;
    }
    saveActiveRowEdits() {
        if (this.editrowproperty.size === 0 || !this.activeitemid) {
            return;
        }
        // lets do something interesting here!
        this.setSavingRow(true);
        const req = {
            letrid: this.activeletrid,
            objectid: this.activeitemid,
            items: Array.from(this.editrowproperty.values()),
            sitems: Array.from(this.metaitems.values())
        };
        Apphandler.sendMessage("addfieldtoobject", req);
    }
    activateDocumentVersion(vinfo) {
        const pobj = this.getProjectObject(this.activeitemid);
        if (pobj && pobj.type === ProjectObjectType.Document) {
            const dob = pobj;
            dob.accesscode = vinfo.boxid,
                dob.accesskey = vinfo.acesskey;
            dob.documentreference = vinfo.filid;
            dob.size = vinfo.size;
            dob.origname = vinfo.name;
            this.updateObject(dob, UpdateType.Version);
        }
    }
    dofilterFolders() {
        if (this.atimeout) {
            clearTimeout(this.atimeout);
        }
        this.atimeout = setTimeout(() => {
            if (!this.filterfolderterm) {
                this.projecttreestate.showAll();
                return;
            }
            // lets try filtering these items now!!
            const items = Array.from(this.folders.values()).filter((fol) => fol.name.toLowerCase().indexOf(this.filterfolderterm) !== -1);
            this.projecttreestate.hideAll();
            if (items.length === 0) {
            }
            else {
                this.projecttreestate.hideOrShowItems(ROOTFolder, false);
                // lets show these items and their parent
                for (const item of items) {
                    this.projecttreestate.hideOrShowItems(item.id, false);
                    let parent = item.parentid;
                    while (parent !== ROOTFolder) {
                        const pf = this.folders.get(parent);
                        if (pf === undefined) {
                            break;
                        }
                        this.projecttreestate.hideOrShowItems(parent, false);
                        parent = pf === null || pf === void 0 ? void 0 : pf.parentid;
                    }
                }
            }
        }, 50);
    }
    setFilterFolderTerm(term) {
        this.filterfolderterm = term.trim();
        this.dofilterFolders();
    }
    setFolders(folder) {
        const nodes = [];
        folder.forEach((f) => {
            const fobj = f;
            this.addFolder(fobj);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: fobj.childrencount,
                color: fobj.color
            };
            nodes.push(treenode);
            console.log("SEtting folder id " + f.id + " " + fobj);
            this.projectsobject.set(f.id, fobj);
        });
        nodes.push({
            id: ROOTFolder,
            label: 'Home',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setActiveItem(ROOTFolder);
        this.projecttreestate.setExpandedNode(ROOTFolder, true);
    }
    setHome() {
        this.projecttreestate.reset();
        const nodes = [];
        this.folders.forEach((f) => {
            const fobj = f;
            this.addFolder(fobj);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: fobj.childrencount,
                color: fobj.color
            };
            nodes.push(treenode);
        });
        nodes.push({
            id: ROOTFolder,
            label: 'Home',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setExpandedNode(ROOTFolder, true);
    }
    setTrash() {
        this.projecttreestate.reset();
        const nodes = [];
        this.folders.forEach((f) => {
            this.addFolder(f);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: f.childrencount
            };
            nodes.push(treenode);
        });
        nodes.push({
            id: TRASHFolder,
            label: 'Trash',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setExpandedNode(TRASHFolder, true);
    }
    setViewerActive(active) {
        this.vieweractive = active;
        if (!active) {
            this.setOpenViewerMenu(false);
        }
    }
    setOpenViewerMenu(show) {
        this.openviewermenu = show;
    }
    showDropZone(show) {
        console.log("showing dropzone " + show);
        this.showdropzone = show;
    }
    resetSelctedFolders() {
        this.selectedFolder = [];
        this.projecttreestate.setActiveItem("");
    }
    setShowSearchResult(show) {
        this.showsearchresult = show;
    }
    setLoadingMoreSearch(loading) {
        this.loadingmoresearch = loading;
    }
    loadMoreSearch() {
        if (this.searchmatches.length > 0) {
            const req = {
                letrid: this.activeletrid,
                ids: this.searchmatches.splice(0, 50),
                reqid: this.searchterm
            };
            this.setLoadingMoreSearch(true);
            Apphandler.sendMessage("driveprojectids", req);
        }
        else {
            this.setLoadingMoreSearch(false);
        }
    }
    setSearchFoundMessage(msg) {
        this.foundmsg = msg;
    }
    setSearchProgess(msg) {
        this.searchprogressmessage = msg;
    }
    addSearchResult(res) {
        this.searchstore.set(res.id, res);
    }
    resetSearch() {
        this.setSearching(false);
        this.setSearchActive(false);
        this.setSearchTerm("");
        this.searchstore.clear();
        this.setSearchProgess("");
        this.setSearchFoundMessage("");
        this.setShowSearchResult(false);
        this.projecttreestate.clearSelected();
        this.projecttreestate.setActiveItem("");
        this.setLoadingMoreSearch(false);
        this.setActiveFolderId("");
        this.filterdialogstate.clear();
        this.projecttreestate.showAll();
        this.folders.forEach((f) => this.projecttreestate.updateCount(f.id, f.childrencount));
        this.projecttreestate.updateCount(this.projecttreestate.ROOTID, 0);
    }
    performSearch() {
        if (!this.searchterm.trim() && this.filterdialogstate.valuesbyid.size === 0) {
            return;
        }
        this.setshowfilter(false);
        this.resetSelctedFolders();
        this.searchstore.clear();
        this.setActiveItemid("");
        this.setActiveFolderId("");
        const fil = [];
        if (this.filterdialogstate.valuesbyid.size > 0) {
            for (const [k, val] of this.filterdialogstate.valuesbyid) {
                fil.push(Object.assign(Object.assign({}, val), { id: k }));
            }
        }
        this.setSearchProgess("Searching encrypted database...");
        this.setSearchFoundMessage("");
        this.setSearchActive(true);
        this.setShowSearchResult(true);
        this.setSearching(true);
        const req = {
            letrid: this.activeletrid,
            searchtext: this.searchterm,
            type: SearchDataType.DriveName,
            mfilter: fil
        };
        Apphandler.sendMessage("searchdrive", req);
    }
    setSearching(searching) {
        this.searching = searching;
    }
    setSearchActive(active) {
        this.searchactive = active;
    }
    setSearchTerm(term) {
        this.searchterm = term;
    }
    setActiveItemid(id, addroute = true) {
        this.editrowproperty.clear();
        this.activeitemid = id;
        this.setLoadingInitObject(false);
        this.initobjectid = "";
        this.initnoteid = "";
        this.showpasswordfor.clear();
        if (!id) {
            this.documentTableState.setSelectId("");
        }
        if (addroute) {
            Router.setActveObject(id);
        }
    }
    setEmptyTrashing(em) {
        this.emptytrashing = em;
    }
    setUpdateSecondPanel(update) {
        this.updatesecondpanel = update;
    }
    setRecovering(rc) {
        this.recovering = rc;
    }
    setTrashing(ts) {
        this.trashing = ts;
    }
    setDeleting(ts) {
        this.deleteingitems = ts;
    }
    setCutPasting(pasting) {
        this.cutpasting = pasting;
    }
    setCopyPasting(pasting) {
        this.copypasting = pasting;
    }
    clearTrash() {
        this.projectsobject.clear();
        this.clearSelectedItems();
        // lets delete everything inside trash
        const trashitems = Array.from(this.folders.values()).filter((f) => f.parentid === TRASHFolder);
        trashitems.forEach((ti) => this.folders.delete(ti.id));
        this.setTrash();
    }
    setActiveFolderSelection(sel) {
        if (sel) {
            this.fullfolderselected.add(this.activefolderid);
        }
        else {
            this.fullfolderselected.delete(this.activefolderid);
        }
        this.projectsobject.forEach((val, key) => this.setObjectSelection(key, sel));
    }
    clearSelectedItems() {
        this.selecteditems.clear();
        this.actvefolderselectitem.clear();
        this.fullfolderselected.clear();
        this.projecttreestate.clearSelected();
    }
    setObjectSelection(id, sel) {
        if (sel) {
            this.selecteditems.add(id);
            if (this.projectsobject.has(id)) {
                this.actvefolderselectitem.add(id);
            }
            if (this.copyitems.size > 0) {
                this.addToCopyItems(id);
            }
            if (this.cutitems.size > 0) {
                this.addToCutItems(id);
            }
        }
        else {
            this.selecteditems.delete(id);
            if (this.projectsobject.has(id)) {
                this.actvefolderselectitem.delete(id);
            }
            if (this.actvefolderselectitem.size === 0) {
                this.fullfolderselected.delete(this.activefolderid);
            }
            if (this.copyitems.has(id)) {
                this.removeFromCopyItems(id);
            }
            if (this.cutitems.has(id)) {
                this.removeFromCutItems(id);
            }
        }
    }
    removeItemFromProjectObject(id) {
        this.projectsobject.delete(id);
    }
    setOpenActionMenu(open) {
        this.openactionmenu = open;
    }
    addSelected(name, id) {
        this.selectedFolder.push({ folderid: id, name: name, index: this.selectedFolder.length });
    }
    removeTill(index) {
        for (let i = this.selectedFolder.length - 1; i > index; i--) {
            this.selectedFolder.pop();
        }
        const last = this.selectedFolder[this.selectedFolder.length - 1];
        this.setActiveFolderId(last.folderid);
        this.loadFolderContent();
    }
    addProjectObject(obj) {
        if (obj.parentid === this.activefolderid) {
            this.projectsobject.set(obj.id, obj);
            const robj = this.makeObjectForTable(obj);
            if (robj !== undefined) {
                robj.rowindex = this.documentTableState.row.size;
                this.documentTableState.addRow(robj);
            }
        }
        if (obj.type === ProjectObjectType.Folder) {
            const fobj = obj;
            this.addFolder(fobj);
            const treenode = {
                id: obj.id,
                children: [],
                label: obj.name,
                parentid: obj.parentid,
                color: fobj.color,
                displaycount: (fobj).childrencount
            };
            this.projectsobject.set(obj.id, obj);
            this.projecttreestate.addChild(treenode);
        }
        if (obj.parentid !== ROOTFolder && obj.parentid !== TRASHFolder) {
            this.projecttreestate.increamentCount(1, obj.parentid);
        }
    }
    getProjectObject(id) {
        return this.projectsobject.get(id);
    }
    updateObject(po, updatetype) {
        this.updatetype = updatetype;
        const req = {
            letrid: this.activeletrid,
            project: po
        };
        Apphandler.sendMessage("updateproject", req);
    }
    updateActiveObjectVersion(detail) {
        const pobj = this.getProjectObject(this.activeitemid);
        if (pobj && pobj.type === ProjectObjectType.Document) {
            const dob = pobj;
            dob.accesscode = detail.databoxid,
                dob.accesskey = detail.accesskey;
            dob.documentreference = detail.fileid;
            dob.size = detail.size;
            dob.origname = detail.filename;
            this.updateObject(dob, UpdateType.Version);
        }
    }
    addVersion(detail) {
        const pobj = this.getProjectObject(this.activeitemid);
        if (pobj && pobj.type === ProjectObjectType.Document) {
            this.udatingversion = detail;
            const vinfo = {
                name: detail.filename,
                isDownloadable: detail.isDownloadable,
                filid: detail.fileid,
                boxid: detail.databoxid,
                versionnumber: 1,
                acesskey: detail.accesskey,
                size: detail.size,
                creatorid: this.userid
            };
            const areq = {
                letrid: this.activeletrid,
                objectid: this.activeitemid,
                vinfo: vinfo
            };
            Apphandler.sendMessage("addversion", areq);
        }
    }
    addDocumentObject(detail) {
        const doc = {
            name: detail.filename,
            accesscode: detail.databoxid,
            accesskey: detail.accesskey,
            documentreference: detail.fileid,
            size: detail.size,
            versions: [{
                    name: detail.filename,
                    isDownloadable: detail.isDownloadable,
                    filid: detail.fileid,
                    boxid: detail.databoxid,
                    versionnumber: 1,
                    acesskey: detail.accesskey,
                    size: detail.size,
                    creatorid: this.userid
                }],
            type: ProjectObjectType.Document,
            parentid: this.activefolderid,
            updatetime: 0,
            id: "",
            origname: detail.filename,
            accessids: []
        };
        const req = {
            letrid: this.activeletrid,
            project: doc
        };
        this.ongoingcreaterequests++;
        Apphandler.sendMessage("createproject", req);
        // lets now add this 
    }
    loadVersions() {
        VDState.setLoading(true);
        const getv = {
            letrid: this.activeletrid,
            objectid: this.activeitemid
        };
        Apphandler.sendMessage("getversion", getv);
    }
    addDocumentObjectForMessage(detail) {
        const doc = {
            name: detail.filename,
            accesscode: detail.databoxid,
            accesskey: detail.accesskey,
            documentreference: detail.fileid,
            size: detail.size,
            versions: [{
                    name: detail.filename,
                    isDownloadable: detail.isDownloadable,
                    filid: detail.fileid,
                    boxid: detail.databoxid,
                    versionnumber: 1,
                    acesskey: detail.accesskey,
                    size: detail.size,
                    creatorid: this.userid
                }],
            type: ProjectObjectType.Document,
            parentid: ROOTFolder,
            updatetime: 0,
            id: "",
            origname: detail.filename,
            accessids: []
        };
        const req = {
            letrid: this.activeletrid,
            project: doc
        };
        this.ongoingcreaterequests++;
        Apphandler.sendMessage("createproject", req);
        // lets now add this 
    }
    resetProjectObjects() {
        this.projectsobject.clear();
    }
    getSize(ob) {
        if (ob.type === ProjectObjectType.Document) {
            const dob = ob;
            return formatBytes(dob.size);
        }
        else if (ob.type === ProjectObjectType.Folder) {
            const fob = ob;
            return fob.childrencount + " item" + (fob.childrencount > 1 ? 's' : '');
        }
        return "";
    }
    getModified(ob) {
        return DateLib.displayDate(ob.updatetime);
    }
    addProjectObjects(objs) {
        const drows = [];
        objs.sort((o1, o2) => o1.updatetime - o2.updatetime);
        objs.forEach((ob, index) => {
            let add = true;
            if (this.searchactive) {
                const index = this.searchmatches.indexOf(ob.id);
                if (index > -1) {
                    add = true;
                }
                else {
                    add = false;
                }
            }
            if (add) {
                const robj = this.makeObjectForTable(ob);
                if (robj !== undefined) {
                    robj.rowindex = index;
                    drows.push(robj);
                }
            }
        });
        this.documentTableState.addRows(drows);
    }
    getObject(id) {
        return this.projectsobject.get(id);
    }
    makeObjectForTable(ob) {
        this.projectsobject.set(ob.id, ob);
        if (this.selecteditems.has(ob.id)) {
            this.actvefolderselectitem.add(ob.id);
        }
        if (ob.type !== ProjectObjectType.Folder) {
            const dcol = [];
            if (!this.hidecoilumn.has("name")) {
                dcol.push({ id: ob.id + "_name", data: ob.name });
            }
            if (!this.hidecoilumn.has("type")) {
                dcol.push({
                    id: ob.id + "_type", data: ob.type, type: ob.type,
                    drafttype: ob.type === ProjectObjectType.Draft ? ob.drafttype : undefined
                });
            }
            if (!this.hidecoilumn.has("size")) {
                dcol.push({ id: ob.id + "_size", data: this.getSize(ob) });
            }
            if (!this.hidecoilumn.has("lastmodified")) {
                dcol.push({ id: ob.id + "_mod", data: this.getModified(ob) });
            }
            this.getMetadata().forEach((mt) => {
                if (!this.hidecoilumn.has(mt.id)) {
                    dcol.push({
                        id: "custom_" + mt.id,
                        data: "",
                    });
                }
            });
            return {
                rowindex: 0,
                row: dcol,
                id: ob.id
            };
        }
        return undefined;
    }
    addProjectObjectsByFolder(objs, folderid) {
        this.projectobjectsByFolderId.set(folderid, objs);
    }
    setActiveFolderId(id) {
        if (this.loading || id === this.activefolderid) {
            return;
        }
        this.setShowSearchResult(false);
        this.resetProjectObjects();
        this.actvefolderselectitem.clear();
        this.documentTableState.clearRows();
        this.activefolderid = id;
        this.loadFolderContent();
    }
    loadAllFolders() {
        if (this.loadedfolder === 1 || !this.activeletrid) {
            return;
        }
        this.projecttreestate.setArranging(true);
        this.loadedfolder = 1;
        const req = { letrid: this.activeletrid, isChooser: false };
        Apphandler.sendMessage("getprojectfolder", req);
    }
    loadFolderContent() {
        if (this.loading || !this.activefolderid) {
            return;
        }
        this.setLoading(true);
        console.log('loading folder ' + this.activefolderid);
        this.activefolderselected.add(this.activefolderid);
        const req = {
            letrid: this.activeletrid,
            parentid: this.activefolderid,
            isChooser: false
        };
        Apphandler.sendMessage("getprojects", req);
    }
    getParentCountForId(obj, pcount) {
        if (obj.parentid === ROOTFolder) {
            return pcount;
        }
        let pobj = this.projectsobject.get(obj.parentid);
        if (pobj !== undefined) {
            pcount++;
            console.log("not undefined pcount " + pcount);
            pcount = this.getParentCountForId(pobj, pcount);
        }
        return pcount;
    }
    hideCol(id) {
        this.hidecoilumn.add(id);
        this.addHeaders();
    }
    showCol(id) {
        this.hidecoilumn.delete(id);
        this.addHeaders();
    }
    addFolder(folder) {
        this.folders.set(folder.id, folder);
    }
    removeFolder(id) {
        this.folders.delete(id);
    }
    setActiveLetr(id) {
        if (this.atimeout) {
            clearTimeout(this.atimeout);
        }
        this.projectsobject.clear();
        this.filterdialogstate.clear();
        this.setshowfilter(false);
        this.setShowColView(false);
        this.hidecoilumn.clear();
        this.cview.splice(0, this.cview.length);
        this.metaitems.clear();
        this.setLoadingInitObject(false);
        this.trashactive = false;
        this.projecttreestate.reset();
        this.memberDetail = [];
        this.activeletrid = id;
        this.loadState = -1;
        this.setActiveFolderId("");
        this.selectedFolder.splice(1, this.selectedFolder.length);
        this.setLoading(false);
        this.selecteditems.clear();
        this.fullfolderselected.clear();
        this.actvefolderselectitem.clear();
        this.documentTableState.clearRows();
        this.resetCopyItems();
        this.resetCutItems();
        this.loadedfolder = -1;
        this.resetSearch();
        this.folders.clear();
        this.showDropZone(false);
    }
    addToCutItems(id) {
        const po = this.projectsobject.get(id);
        if (po === undefined) {
            return;
        }
        this.cutitems.add(id);
        this.cutItemsProjectObject.set(id, po);
    }
    removeFromCutItems(id) {
        const po = this.projectsobject.get(id);
        if (po === undefined) {
            return;
        }
        this.cutitems.delete(id);
        this.cutItemsProjectObject.delete(id);
    }
    performCut() {
        if (this.cutpasting) {
            return;
        }
        if (this.cutitems.size > 0) {
            this.setCutPasting(true);
            this.moveItems(Array.from(this.cutitems), this.activefolderid);
        }
    }
    deleteItems() {
        this.setDeleting(true);
        const req = {
            letrid: this.activeletrid,
            project: Array.from(this.selecteditems),
            newparentid: "",
            delete: true
        };
        Apphandler.sendMessage("moveobject", req);
    }
    moveItems(items, newparentid) {
        const req = {
            letrid: this.activeletrid,
            project: items,
            newparentid: newparentid,
            delete: false
        };
        Apphandler.sendMessage("moveobject", req);
    }
    performCopy() {
        if (this.copypasting) {
            return;
        }
        if (this.copyitems.size > 0) {
            this.setCopyPasting(true);
            for (const [item, po] of this.copyItemsProjectObject) {
                const req = {
                    letrid: this.activeletrid,
                    project: Object.assign(Object.assign({}, po), { parentid: this.activefolderid }),
                    iscopy: true,
                    mainitemid: po.id
                };
                this.ongoingcreaterequests++;
                Apphandler.sendMessage("createproject", req);
            }
        }
    }
    emptyTrash() {
        this.setEmptyTrashing(true);
        Apphandler.sendMessage("emptytrash", this.activeletrid);
    }
    showHome(clearsel = true) {
        if (clearsel) {
            this.clearSelectedItems();
        }
        if (this.trashactive) {
            this.setHome();
        }
        this.trashactive = false;
        this.setActiveFolderId(ROOTFolder);
        this.selectedFolder = [];
        this.selectedFolder[0] = {
            folderid: ROOTFolder,
            name: "Home",
            index: 0
        };
    }
    showTrash() {
        this.clearSelectedItems();
        this.trashactive = true;
        // lets now do something interesting here!!
        this.setActiveFolderId(TRASHFolder);
        this.selectedFolder = [];
        this.selectedFolder[0] = {
            folderid: TRASHFolder,
            name: "Trash",
            index: 0
        };
        this.setTrash();
    }
    recover() {
        if (this.selecteditems.size === 0) {
            return;
        }
        this.setRecovering(true);
        this.moveItems(Array.from(this.selecteditems), ROOTFolder);
    }
    trashItems() {
        if (this.selecteditems.size === 0) {
            return;
        }
        this.setTrashing(true);
        this.moveItems(Array.from(this.selecteditems), TRASHFolder);
    }
    addToCopyItems(id) {
        const po = this.projectsobject.get(id);
        // folder not allowed
        if (po === undefined || po.type === ProjectObjectType.Folder) {
            return;
        }
        this.copyitems.add(id);
        this.copyItemsProjectObject.set(id, po);
    }
    removeFromCopyItems(id) {
        const po = this.projectsobject.get(id);
        // folder not allowed
        if (po === undefined || po.type === ProjectObjectType.Folder) {
            return;
        }
        this.copyitems.delete(id);
        this.copyItemsProjectObject.delete(id);
    }
    resetCutItems() {
        this.cutitems.clear();
        this.cutItemsProjectObject.clear();
    }
    resetCopyItems() {
        this.copyitems.clear();
        this.copyItemsProjectObject.clear();
    }
    setLoading(loading) {
        this.loading = loading;
    }
    getObjects() {
        let objs;
        if (this.searchactive && this.showsearchresult) {
            objs = Array.from(this.searchstore.values());
        }
        else {
            objs = Array.from(this.projectsobject.values());
        }
        return objs.sort((a, b) => {
            if (a.type !== b.type) {
                if (a.type === ProjectObjectType.Folder) {
                    return -1;
                }
                if (b.type === ProjectObjectType.Folder) {
                    return 1;
                }
            }
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    }
    getObjectsByFolderId() {
        let objs = this.projectobjectsByFolderId.get(this.activefolderid);
        if (objs !== undefined) {
            objs = Array.from(objs);
            return objs.sort((a, b) => {
                if (a.type !== b.type) {
                    if (a.type === ProjectObjectType.Folder) {
                        return -1;
                    }
                    if (b.type === ProjectObjectType.Folder) {
                        return 1;
                    }
                }
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
        }
        return [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "projectsobject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "searchstore", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "actvefolderselectitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ProjectStore.prototype, "cview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "activeletrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "activefolderid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "openviewermenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "openactionmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "selecteditems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "trashing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "deleteingitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "showsearchresult", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "hidecoilumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "fullfolderselected", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], ProjectStore.prototype, "updatetype", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "copyitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "cutitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "cutItemsProjectObject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "copyItemsProjectObject", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "cutpasting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "copypasting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "recovering", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "showcolview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "emptytrashing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "updatesecondpanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "searchactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "searching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "searchterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "filterfolderterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "savingrow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "foundmsg", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "metaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "editrowproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "myperm", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ProjectStore.prototype, "showpasswordfor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "searchprogressmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "loadingmoresearch", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ProjectStore.prototype, "showdropzone", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "trashactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "folders", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ProjectStore.prototype, "vieweractive", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ProjectStore.prototype, "selectedFolder", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectStore.prototype, "loadinginitobject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ProjectStore.prototype, "projectobjectsByFolderId", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], ProjectStore.prototype, "showfolderview", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setShowFolderView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setMyLetrPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "clearMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setShowPasswordFor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setHidePasswordFor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setShowColView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setshowfilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removePropertiesFromActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setPropertiesForActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setLoadingInitObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addColumnViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSavingRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setFilterFolderTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setViewerActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setOpenViewerMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "showDropZone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "resetSelctedFolders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setShowSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setLoadingMoreSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSearchFoundMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSearchProgess", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "resetSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "performSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSearching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSearchActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setSearchTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setEmptyTrashing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setUpdateSecondPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setRecovering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setTrashing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setDeleting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setCutPasting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setCopyPasting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "clearTrash", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setActiveFolderSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "clearSelectedItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setObjectSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removeItemFromProjectObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setOpenActionMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removeTill", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addProjectObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "updateObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "resetProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addProjectObjectsByFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setActiveFolderId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "hideCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "showCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removeFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addToCutItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removeFromCutItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "showHome", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "showTrash", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "addToCopyItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "removeFromCopyItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "resetCutItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "resetCopyItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectStore.prototype, "setLoading", null);
